var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":_vm.value ? 'green' : 'red',"small":""}},[_vm._v(" "+_vm._s(_vm.value ? "mdi-check-circle-outline" : "mdi-close-circle-outline")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }